import { TaskCard } from "./TaskCard";

interface TasksGridProps {
	tasks: any[];
	onTaskUpdated?: () => void;
}

export const TasksGrid = ({ tasks, onTaskUpdated }: TasksGridProps) => {
	return (
		<div
			className="grid gap-5 overflow-visible pb-8 pr-8"
			style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}
		>
			{tasks.map((task) => (
				<TaskCard key={task.id} task={task} onTaskUpdated={onTaskUpdated} />
			))}
		</div>
	);
};
